import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: {}
})

async function loadTranslations (client) {
  const locales = await import(`./assets/client/${client}/locales/index.js`)
  Object.entries(locales.default).forEach(([lang, localeMessages]) => {
    i18n.setLocaleMessage(lang, localeMessages)
  })
}

function prepareLocale () {
  let locale = window.localStorage.getItem('locale')

  if (locale !== null) {
    i18n.locale = locale
  }
}

loadTranslations(process.env.CLIENTID)
prepareLocale()

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js